import {AttributeLink, AttributeSetup, content, Engine, getNodes, link} from '@acng/frontend-stargazer';
import {create, TEMPLATE} from '@acng/frontend-bounty/dom/element.js';
import {after, remove, replace} from '@acng/frontend-bounty/dom/move.js';
import {append} from '@acng/frontend-bounty/dom/template.js';
import {get, has, set, unset} from '@acng/frontend-bounty/dom/attribute.js';
import {isHTMLElement} from '@acng/frontend-bounty/dom/type.js';
import {guard, IS_ELEMENT} from '@acng/frontend-rubicon';

import {CHANGE, off, on} from '@acng/frontend-bounty/dom/event.js';
import {getState} from '../context/state';
import {debug} from '@acng/frontend-bounty/dom/debug.js';
import {findOrCreate} from '../service/state';
import {OUT_STATE} from './out-state';
import {each} from '@acng/frontend-bounty/std/array.js';
import {enterNode, leaveNode} from 'acng/layout/service/animate-class';

/**
 * If the state does not exist it is considered inactive.
 *
 * TODO Support optional states. (if-state="state1,state2")
 *
 * @group DOM Attribute
 */
const attributeName = 'if-state';

AttributeSetup(attributeName, (name) => {
  AttributeLink(name, (element, value) => {
    if (!isHTMLElement(element, TEMPLATE)) {
      return;
    }

    const engine = new Engine(element);

    return () => {
      const origin = getState(element);
      const state = findOrCreate(element, origin, value, true);
      DEBUG: if (debug(element)) console.info(`[${attributeName}] uses`, {origin, value, state, element});

      const change = async () => {
        if (state.isActive) {
          //console.log('ACTIVE', {element, state});
          await engine.lookup();

          const fragment = link(engine, state.params, element, () => () => {
            const block = [...fragment.childNodes];

            after(element, ...block);
            each(block, enterNode);

            return () => each(block, leaveNode);
          });

          engine.connect();
        } else {
          //console.log('INACTIVE', {element, state});
          engine.disconnect();
        }
      };

      on(state, CHANGE, change);
      change();

      return () => {
        off(state, CHANGE, change);
        engine.disconnect();
      };
    };
  });

  return (element, value) => {
    if (isHTMLElement(element, TEMPLATE)) {
      return;
    }

    const template = create(TEMPLATE);
    DEBUG: if (debug(element)) set(template, 'debug');

    replace(element, template);
    set(template, attributeName, value);
    unset(element, attributeName);
    append(template, element);

    // Do not just copy all
    const outStateName = get(element, OUT_STATE);

    if (outStateName) {
      set(template, OUT_STATE, outStateName);
    }
  };
});

export {attributeName as IF_STATE};
